import { apiTrackDetails } from "../trackAPI/actions";
import {
  TRACKING_API_DETAILS_FAIL,
  TRACKING_API_DETAILS_REQUEST,
} from "../trackAPI/actionType";
import axios from "./utils/axios";

const fetchTrackingDetails = (orderId) => {
  return async (dispatch) => {
    try {
      dispatch({ type: TRACKING_API_DETAILS_REQUEST });
      const config = {
        headers: {
          "Content-type": "application/json",
        },
      };
      const { data } = await axios.get(`/api/trackOrder/${orderId}/`, config);
      dispatch(apiTrackDetails(data));
    } catch (error) {
      dispatch({
        type: TRACKING_API_DETAILS_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };
};

export default fetchTrackingDetails;
